// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/routes/videos.tsx"
);
import.meta.hot.lastModified = "1723747711679.9133";
}
// REMIX HMR END

import { Outlet } from "@remix-run/react";
import Nav from "~/components/Nav";

export default function videos() {
  return (
    <div
      className="flex flex-col h-full"
    >
      <Nav />
      <section className="flex flex-grow">
        <Outlet />
      </section>
    </div>
  );
}
